<template>
  <div class="vue-tempalte">
    <nav class="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0" style="width: auto; z-index: 4000">
      <div class="container" style="padding: 5px">
        <h3 class="navbar-brand float-left" style="color: white">
          CrawlingService
        </h3>
        <div>
          <div class="dropdown" v-if="userIsAuth === true">
            <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton1"
                    data-bs-toggle="dropdown" aria-expanded="false" style="color:white">
              Options
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li><a class="dropdown-item" href="/jobs">Jobs</a></li>
              <li><a class="dropdown-item" v-if="isUserAdmin" href="/admin/users">Admin</a></li>
              <li><a class="dropdown-item" href="/" v-on:click="logout">Logout</a></li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <div>
      <side-bar v-if="isUserAdmin && adminPath === true "></side-bar>
      <div class="App">
        <div>
          <div class="container">
            <router-view/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import SideBar from "@/components/admin/SideBar";

export default {
  name: "vue-tempalte",
  data() {
    return {
      isUserAdmin: false,
      adminPath: false,
      userIsAuth: false,
    }
  },
  mounted() {
    if (localStorage.getItem('users-token') !== "null") {
      this.userIsAuth = true;
    }
    if (localStorage.getItem("users-role") === 'admin') {
      this.isUserAdmin = true;
    }
    let path = window.location.pathname.split("/");
    for (let i = 0; i < path.length; i++) {
      if (path[i] === 'admin') {
        this.adminPath = true;
      }
    }
  },
  components: {
    'side-bar': SideBar,
  },
  methods: {
    logout: function () {
      localStorage.setItem('users-token', null);
      localStorage.setItem('users-role', null);
      localStorage.removeItem('reloaded');
    }
  }
}
</script>
